import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
export var useDotIndicator = function useDotIndicator() {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isDotShown = _useState2[0],
      setIsDotShown = _useState2[1];

  var removeDot = useCallback(function () {
    return setIsDotShown(false);
  }, []);
  return [isDotShown, removeDot];
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/internals/CSPOnboarding/useDotIndicator.js
// module id = 5609
// module chunks = 11